export default Object.freeze({
    CORE_API_ACCESS_TOKEN_NAME: 'point-of-care-access-token',
});
